module.exports = __webpack_public_path__ + "img/public/SiteIcons/modalCloseIcon.svg?7198e819";